// extracted by mini-css-extract-plugin
module.exports = {"board":"Chessboard_board__2DcmF","row":"Chessboard_row__3JJ4N"};